import React, { useState } from "react";
import { chooseWritingCompanionMomentV1 } from "../utils/writingCompanionPromptV1";

// Display-only encouragement. Never sends email, push, or reminders.
// Uses the already loaded, authenticated Project Hub project list.
export default function WritingCompanionPilotV1({
  lang = "en",
  canWrite = false,
  projects = [],
  onContinue,
  onStart,
  onBrowse,
}) {
  const [dismissed, setDismissed] = useState(false);
  const fr = String(lang).toLowerCase() === "fr";
  const moment = chooseWritingCompanionMomentV1(projects, canWrite);
  if (dismissed) return null;

  const storyTitle = String(moment.project?.title || "").trim();
  const heading = moment.kind === "resume"
    ? (fr ? "Votre histoire vous attend." : "Your story is waiting.")
    : moment.kind === "revisit"
      ? (fr ? "Votre prochaine histoire vous attend." : "Your next story is waiting.")
    : moment.kind === "start"
      ? (fr ? "Chaque histoire commence par une idée." : "Every story starts with an idea.")
      : (fr ? "Découvrez une histoire à aimer." : "Discover a story worth sharing.");

  const message = moment.kind === "resume"
    ? (fr
      ? (storyTitle ? "« " + storyTitle + " » " : "Votre projet ") +
        "est prêt lorsque vous le serez. Quelques lignes suffisent pour reprendre le fil."
      : (storyTitle ? "“" + storyTitle + "” " : "Your project ") +
        "is here whenever you are ready. A few thoughtful lines are enough to begin.")
    : moment.kind === "revisit"
      ? (fr
        ? "Vos histoires publiées restent ici. Explorez vos projets pour commencer un nouveau récit."
        : "Your published stories are here. Explore your projects whenever you are ready to begin another.")
    : moment.kind === "start"
      ? (fr
        ? "Une scène, un personnage ou une simple phrase peuvent ouvrir un nouveau monde."
        : "One scene, one character, or one sentence can open a new world.")
      : (fr
        ? "Explorez les récits de la communauté et trouvez votre prochaine lecture."
        : "Explore the community's stories and find your next great read.");

  const action = moment.kind === "resume"
    ? (fr ? "Reprendre l’écriture" : "Continue Writing")
    : moment.kind === "revisit" || moment.kind === "start"
      ? (fr ? "Explorer les projets" : "Explore Projects")
      : (fr ? "Découvrir les histoires" : "Discover Stories");

  const handleAction = () => {
    if (moment.kind === "resume" && moment.project) {
      onContinue?.(moment.project);
    } else if (moment.kind === "start" || moment.kind === "revisit") {
      onStart?.();
    } else {
      onBrowse?.();
    }
  };

  return (
    <section
      data-writing-companion-pilot-v1="true"
      aria-label={fr ? "Compagnon d’écriture" : "Writing Companion"}
      style={{
        display: "flex", flexWrap: "wrap", alignItems: "center",
        justifyContent: "space-between", gap: 18,
        padding: "22px clamp(20px, 3vw, 30px)", marginBottom: 24,
        borderRadius: 20, border: "1px solid rgba(89,112,82,0.32)",
        background: "linear-gradient(115deg, #f6f4ea 0%, #f1f6ee 100%)",
        boxShadow: "0 7px 24px rgba(30,60,45,0.07)",
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: 16, flex: "1 1 420px" }}>
        <div aria-hidden="true" style={{
          width: 48, height: 48, borderRadius: 15, flex: "0 0 48px",
          display: "grid", placeItems: "center", fontSize: 25,
          color: "#3d6147", background: "#e0eadb",
        }}>✦</div>
        <div style={{ minWidth: 0 }}>
          <div style={{
            color: "#54715a", fontSize: 11, fontWeight: 800,
            letterSpacing: "0.13em", textTransform: "uppercase",
          }}>
            {fr ? "COMPAGNON D’ÉCRITURE" : "WRITING COMPANION"}
          </div>
          <h2 style={{
            color: "#244a37", fontFamily: 'Georgia, "Times New Roman", serif',
            fontSize: "clamp(1.25rem, 2vw, 1.6rem)",
            lineHeight: 1.25, margin: "7px 0 6px",
          }}>{heading}</h2>
          <p style={{ color: "#45564b", margin: 0, lineHeight: 1.55, maxWidth: 630 }}>
            {message}
          </p>
        </div>
      </div>
      <div style={{
        display: "flex", flexDirection: "column", gap: 8,
        flex: "0 1 210px", minWidth: 190,
      }}>
        <button type="button" className="ns-button ns-button-primary"
          data-writing-companion-action="true"
          onClick={handleAction}
          style={{
            background: "#365b42", borderColor: "#365b42",
            borderRadius: 12, width: "100%", padding: "12px 15px",
            color: "#fff", fontWeight: 800,
          }}>{action}</button>
        <button type="button"
          data-writing-companion-dismiss="true"
          onClick={() => setDismissed(true)}
          style={{
            background: "transparent", border: "none", padding: "6px 8px",
            color: "#526b58", cursor: "pointer", fontWeight: 700,
          }}>
          {fr ? "Pas maintenant" : "Not now"}
        </button>
      </div>
    </section>
  );
}
